import React, { useState, useEffect } from "react";
import { withRouter, useHistory, useLocation } from "react-router-dom";
import classNames from "classnames";
import { makeStyles } from "@material-ui/core/styles";
import { Drawer, Hidden, Toolbar, AppBar, List, ListItem } from "@material-ui/core";
import { KeyboardArrowDown, KeyboardArrowUp } from "@material-ui/icons";
import styles from "./../assets/style/headerStyle";

const useStyles = makeStyles(styles);

const Header_Setting = () => {
    const classes = useStyles();
    const [mobileOpen, setMobileOpen] = useState(false);
    const history = useHistory()
    const location = useLocation()
    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const hideMobile = () => {
        setMobileOpen(false)
    }

    useEffect(() => {
        window.addEventListener("resize", hideMobile);
        return function cleanup() {
            window.removeEventListener("resize", hideMobile);
        };
    });

    const appBarClasses = classNames({
        [classes.appBar]: true,
        [classes['com7']]: 'com7',
    });

    const checkPath = () => {
        if (location.pathname.includes("/report1")) return (
            <ListItem className={classes.listItem}>
                Report รวม {!mobileOpen ? <KeyboardArrowDown /> : <KeyboardArrowUp />}
            </ListItem>
        )
        else if (location.pathname.includes("/report2")) return (
            <ListItem className={classes.listItem}>
                Report 1on1 {!mobileOpen ? <KeyboardArrowDown /> : <KeyboardArrowUp />}
            </ListItem>
        )
        else return null
    }

    return (
        <AppBar className={`${appBarClasses}`} style={{ color: "black", marginTop: '7vh', height: '7vh' }}>
            <Toolbar className={classes.container}>
                <Hidden smDown implementation="css">
                    <List className={classes.list} style={{ display: 'flex' }}>
                        <ListItem className={classNames(classes.listItem, "hoverThis")} onClick={() => history.push("/report1")} style={{ cursor: 'pointer', whiteSpace: 'nowrap', borderBottom: location.pathname.indexOf("/report1") != -1 ? '3px solid #6ab23a' : "" }}>
                            Report รวม
                        </ListItem>
                        <ListItem className={classNames(classes.listItem, "hoverThis")} onClick={() => history.push("/report2")} style={{ cursor: 'pointer', whiteSpace: 'nowrap', borderBottom: location.pathname.indexOf("/report2") != -1 ? '3px solid #6ab23a' : "" }}>
                            Report 1on1
                        </ListItem>
                    </List>
                </Hidden>

                <Hidden mdUp>
                    <List className={classes.list} style={{ margin: 'auto', cursor: 'pointer' }} onClick={handleDrawerToggle}>
                        {checkPath()}
                    </List>
                </Hidden>
            </Toolbar>
            <Hidden mdUp implementation="js">
                <Drawer
                    variant="temporary"
                    anchor={"top"}
                    open={mobileOpen}
                    classes={{
                        paper: classes.drawerPaperTop,
                    }}
                    onClose={handleDrawerToggle}
                >
                    <div className={classes.appResponsive}>
                        <List className={classes.list} style={{ padding: '0px' }}>
                            <ListItem className={classNames(classes.listItem, "hoverThis")} onClick={() => history.push("/report1")} style={{ cursor: 'pointer', borderBottom: location.pathname.indexOf("/report1") != -1 ? '3px solid #6ab23a' : "" }}>
                                Report รวม
                            </ListItem>
                            <ListItem className={classNames(classes.listItem, "hoverThis")} onClick={() => history.push("/report2")} style={{ cursor: 'pointer', borderBottom: location.pathname.indexOf("/report2") != -1 ? '3px solid #6ab23a' : "" }}>
                                Report 1on1
                            </ListItem>
                        </List>
                    </div>
                </Drawer>
            </Hidden>
        </AppBar >
    );
}

export default withRouter(Header_Setting)

